import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import type { Protocol } from "@msuite/utils/types";
import { client } from "@/hono";
import { ProtocolsMenu } from "./protocols-menu";
import { columns } from "./table-config";

export function Protocols() {
	/** Hooks */

	/** Query */
	const {
		data: protocols,
		refetch,
		isLoading,
		queryKey,
	} = useQuery({
		queryKey: ["protocols"],
		queryFn: async () => {
			const response = await client.protocols.index.$get({
				query: {},
			});
			const data = await responseHandler(response);
			return data.protocols as Array<Protocol>;
		},
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={protocols}
				columns={columns}
				isLoading={isLoading}
				persistenceKey="protocols-table"
				refetch={refetch}
				queryKey={queryKey}
				menu={<ProtocolsMenu />}
			/>
		</ContentBox>
	);
}
